import { IoLogoWhatsapp } from "react-icons/io5"
import LeadForm, { WHATSAPP_PHONE } from "./LeadForm.jsx"

const CambioForm = () => {
    return (
        <section className="relative w-full pt-16 pb-28 px-5 lg:px-16 bg-sbPallet-bgBlack flex flex-col items-center scroll-mt-20" id="cambio">
            <div aria-hidden="true" className="section-fade-to-card pointer-events-none absolute inset-x-0 bottom-0 h-24"/>
            <h2 className="text-3xl lg:text-4xl font-black uppercase text-center">Reserva tu plaza</h2>
            <p className="mt-3 text-white/70 text-center max-w-md">
                Una vez recibida tu solicitud, revisaré personalmente tu caso y te contactaré para valorar la mejor opción para ti.
            </p>
            <p className="mt-4 text-xs uppercase tracking-widest text-white/50 font-bold">Plazas limitadas cada mes</p>

            <LeadForm
                origen="landing"
                onSuccess={() => document.getElementById("cambio")?.scrollIntoView({ behavior: "smooth", block: "start" })}
            />

            <a
                href={`https://api.whatsapp.com/send/?phone=${WHATSAPP_PHONE}&text&type=phone_number&app_absent=0`}
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:scale-110 ease-in duration-100 z-50"
                aria-label="Escríbeme por WhatsApp"
            >
                <IoLogoWhatsapp className="text-white" size={30} />
            </a>
        </section>
    )
}

export default CambioForm
